import { ACCOUNT_LEVEL } from 'constants/AppConstants';

export const getRecentOrdersColumns = (t, classes) => [
  { label: t('order_submitted__report_number'), dataKey: 'reportId' },
  { label: t('common__product'), dataKey: 'product' },
  { label: t('order_submitted__address'), dataKey: 'address' },
  { label: t('common__date'), dataKey: 'date' },
  { label: t('common_delivery'), dataKey: 'delivery' },
  { label: t('common__status'), dataKey: 'status' },
  { label: '', dataKey: 'actions', cellProps: { className: classes.actionsCell } },
];

export const getUpgradeAccountLevel = (currentLevel) => {
  switch (currentLevel) {
    case ACCOUNT_LEVEL.BRONZE:
      return ACCOUNT_LEVEL.SILVER;
    case ACCOUNT_LEVEL.SILVER:
      return ACCOUNT_LEVEL.GOLD;
    case ACCOUNT_LEVEL.GOLD:
      return ACCOUNT_LEVEL.PLATINUM;
    default: return '';
  }
};
